var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgG4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113431",
    "data-name": "Rectangle 113431",
    width: 43,
    height: 43.008,
    fill: "#b2b9bf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_334302",
    "data-name": "Group 334302",
    transform: "translate(7530 -29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114336",
    "data-name": "Rectangle 114336",
    width: 72,
    height: 72,
    transform: "translate(-7530 29)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_334301",
    "data-name": "Group 334301",
    transform: "translate(-7843.5 -448.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337472",
    "data-name": "Path 337472",
    d: "M331.165,497v8.487l12.088,2.829,3.6,7.587v14.4s11.7.643,11.7,0V505.487h-11.7V497Z",
    transform: "translate(9.946 2.347)",
    fill: "#1a2024"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16269",
    "data-name": "Ellipse 16269",
    cx: 6.874,
    cy: 6.874,
    r: 6.874,
    transform: "translate(333.347 517.678)",
    fill: "#1a2024"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_332146",
    "data-name": "Group 332146",
    transform: "translate(328 494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_332145",
    "data-name": "Group 332145",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337469",
    "data-name": "Path 337469",
    d: "M24.391,42.893c.325-.275.623-.511.9-.767A15.3,15.3,0,0,0,20.8,16.505a14.87,14.87,0,0,0-8.267-.845c-.394.072-.495-.048-.494-.434.012-3.592,0-7.184.014-10.777A4.566,4.566,0,0,1,16.47.015C21.994,0,27.518.013,33.042,0c.422,0,.548.131.545.548-.017,2.283-.014,4.567,0,6.85a5,5,0,0,0,.392,2.1,4.548,4.548,0,0,0,4.433,2.767c2.267.022,4.534,0,6.8.006.632,0,.634,0,.634.635q0,12.716,0,25.433A4.57,4.57,0,0,1,41.21,43q-8.143.011-16.285,0a.765.765,0,0,1-.534-.1m-.044-30.622c1.484,0,2.969.013,4.452,0a1.507,1.507,0,0,0,1.538-1.987A1.6,1.6,0,0,0,28.7,9.274q-4.356,0-8.713,0a2.291,2.291,0,0,0-.707.1,1.463,1.463,0,0,0-.626,2.372,1.686,1.686,0,0,0,1.335.526q2.178,0,4.356,0m10.731,4.67c-1.005,0-2.011-.022-3.015.006a1.518,1.518,0,0,0-1.541,1.511,1.537,1.537,0,0,0,1.539,1.468c2.01.024,4.021.018,6.031,0a1.539,1.539,0,0,0,1.444-1,1.5,1.5,0,0,0-1.491-1.985c-.988-.024-1.978,0-2.967,0M36.593,27.6c.479,0,.957.012,1.435,0a1.5,1.5,0,1,0-.014-2.99q-1.41-.024-2.822,0a1.529,1.529,0,0,0-1.6,1.5A1.574,1.574,0,0,0,35.206,27.6c.462.013.925,0,1.387,0m.022,4.669c-.478,0-.957-.013-1.435,0a1.535,1.535,0,0,0-1.592,1.511,1.561,1.561,0,0,0,1.582,1.477c.956.021,1.914.02,2.87,0a1.5,1.5,0,1,0,.01-2.989c-.478-.016-.957,0-1.435,0",
    transform: "translate(-2.844 0)",
    fill: "#d0d9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337470",
    "data-name": "Path 337470",
    d: "M24.6,36.391A12.3,12.3,0,1,1,12.259,24.082,12.284,12.284,0,0,1,24.6,36.391M9.219,40.952a1.9,1.9,0,0,0,1.276-.637q2.854-2.867,5.718-5.723a3.145,3.145,0,0,0,.348-.394,1.465,1.465,0,0,0-.849-2.308,1.526,1.526,0,0,0-1.544.529q-2.914,2.909-5.821,5.823a2.424,2.424,0,0,0-.388.483,1.39,1.39,0,0,0,.017,1.5,1.522,1.522,0,0,0,1.244.73M9.21,34.809a1.486,1.486,0,1,0,.005-2.972,1.486,1.486,0,0,0-.005,2.972M15.4,40.943a1.55,1.55,0,0,0,1.455-1.494A1.521,1.521,0,0,0,15.39,37.97a1.487,1.487,0,1,0,.011,2.973",
    transform: "translate(0 -5.688)",
    fill: "#d0d9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337471",
    "data-name": "Path 337471",
    d: "M44.26,1.251c.142.128.252.218.351.318q3.774,3.772,7.544,7.548c.106.106.318.2.247.369s-.286.079-.438.079q-3.062.007-6.125,0A1.546,1.546,0,0,1,44.166,7.9c0-2.058,0-4.115,0-6.173a.755.755,0,0,1,.094-.478",
    transform: "translate(-10.431 -0.295)",
    fill: "#1a2024"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG4);
export default __webpack_public_path__ + "static/media/g4.0aea77c70113f89c0dd22c61ed921318.svg";
export { ForwardRef as ReactComponent };